import React from "react";
import { Rate } from "rsuite";
import { imageBanner } from "../common/data";

const ImageBanner = ({
  title,
  show,
  heading,
  onClick,
  logo,
  rating,
  imageClass,
  image,
}) => {
  const random = Math.floor(Math.random() * imageBanner.length);
  return (
    <div className="d-flex justify-content-center position-relative">
      <img
        className="banner"
        src={
          image !== null && image !== undefined
            ? image
            :title == 'DEALS'
                  ? imageBanner[8].src
                  : imageBanner[random].src
        }
        alt="Image"
      />
      <div className="trip-banner-title">
        {logo && (
          <img
            src={logo}
            alt=""
            className={`class-logo ${imageClass ? imageClass : ""}`}
          />
        )}
        {title && <p className="text--shadow">{title}</p>}
        {heading && <h4 className="text--shadow">{heading}</h4>}
        {show ? (
          <button className="default-button button" onClick={onClick}>
            <span className="text-capitalize">Submit Testimonial</span>
          </button>
        ) : null}
      </div>
      {rating ? (
        <div className="rating-stars-style-rsuite blur-filter-overlay rounded">
          <div className="rating-box p-1">
            <Rate disabled max={5} size="xs" defaultValue={rating} allowHalf />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ImageBanner;
